module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry_checklist-52ffaaa6abda029bb31facdc47e74a4b.svg";